import Vue from 'vue';

Vue.filter('filterAmount', function (value) {
    if (!value) return 0
    const formatter = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 0
    })
    return formatter.format(value);
})

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('upperCase', function (value) {
    if (!value) return '';
    return value.toUpperCase()
})
Vue.filter('lowerCase', function (value) {
    if (!value) return '';
    return value.toLowerCase()
})

Vue.filter('capitalize_word', function (value) {
    if (!value) return '';
    return value.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
})

Vue.prototype.$convertSecondsToMinute = function (seconds) {
    var hours = Math.floor(seconds / 60);
    var minutes = seconds % 60;
    return hours + ":" + minutes + " min read time";
};

const Swal = require('sweetalert2')
Vue.prototype.$throwSwalError = function (error) {
    if (error.hasOwnProperty('response')){
        if (error.response.status == 419) {
            Swal.fire({
                title: 'Session Expired!',
                text: 'Please refresh the page and try again',
                icon: "error",
            })
        }else {
            if (error.response.hasOwnProperty('data')
                && error.response.data.hasOwnProperty('message')) {
                let msg = error.response.data.message;
                const status = error.response.status;
                if (!msg) {
                    if (status == 500) {
                        msg = 'Internal Server Error'
                    }else if (status == 401){
                        msg = 'User does not have permission';
                    }else if (status == 403){
                        msg = "Page is refreshing."
                        window.location.href = window.location.href;
                    }
                }
                Swal.fire({
                    title: error.response.status,
                    text: msg,
                    icon: "error",
                })
            }
        }
    }

}



